interface GetFullNameProps {
  firstName?: string;
  lastName?: string;
}

export function getFullName({ firstName, lastName }: GetFullNameProps): string {
  return `${firstName || ''} ${lastName || ''}`.trim();
}
